import { render } from "./EmpresaForm.vue?vue&type=template&id=ff89082c&scoped=true"
import script from "./EmpresaForm.vue?vue&type=script&lang=js"
export * from "./EmpresaForm.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=ff89082c&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=ff89082c&scoped=true&lang=css"
import "./EmpresaForm.vue?vue&type=style&index=2&id=ff89082c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff89082c"]])

export default __exports__